(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-premium-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCPP(section) {
      if (!section || section.dataset.cppInit === 'true') return;
      section.dataset.cppInit = 'true';

      var config = {};
      try {
        var cfgEl = section.querySelector('[data-cpp-config]');
        if (cfgEl) config = JSON.parse(cfgEl.textContent);
      } catch (e) { config = {}; }

      var variants = [];
      try {
        var vEl = section.querySelector('[data-cpp-variant-json]');
        if (vEl) variants = JSON.parse(vEl.textContent);
      } catch (e) { variants = []; }

      var form         = section.querySelector('[data-cpp-form]');
      var variantInput = section.querySelector('[data-cpp-variant-id]');
      var priceCurrent = section.querySelector('[data-cpp-current-price]');
      var priceCompare = section.querySelector('[data-cpp-compare-price]');
      var saveBadge    = section.querySelector('[data-cpp-save-badge]');
      var savePct      = section.querySelector('[data-cpp-save-pct]');
      var atcBtn       = section.querySelector('[data-cpp-add-to-cart]');
      var atcText      = section.querySelector('[data-cpp-atc-text]');
      var stockText    = section.querySelector('[data-cpp-stock-text]');
      var stockNotice  = section.querySelector('[data-cpp-stock-notice]');
      var optionInputs = section.querySelectorAll('[data-cpp-option-input]');
      
      var qtyInput     = section.querySelector('[data-cpp-qty-input]');
      var qtyMinus     = section.querySelector('.cpp-qty-minus');
      var qtyPlus      = section.querySelector('.cpp-qty-plus');

      var thumbsWrap   = section.querySelector('[data-cpp-thumbnails]');
      var thumbnails   = Array.prototype.slice.call(section.querySelectorAll('.cpp-thumbnail-btn'));
      var mainMedia    = section.querySelector('[data-cpp-main-media]');
      var mediaItems   = Array.prototype.slice.call(section.querySelectorAll('.cpp-media-item'));
      var thumbUp      = section.querySelector('[data-cpp-thumb-up]');
      var thumbDown    = section.querySelector('[data-cpp-thumb-down]');

      var mobLeft      = section.querySelector('.cpp-mob-left');
      var mobRight     = section.querySelector('.cpp-mob-right');

      var cartOverlay  = section.querySelector('[data-cpp-cart-overlay]');
      var cartToast    = section.querySelector('[data-cpp-cart-toast]');
      var cartBody     = section.querySelector('[data-cpp-cart-body]');
      var cartClose    = section.querySelector('[data-cpp-cart-close]');

      function openCartToast() {
        if (!cartToast || !cartOverlay) return;
        cartOverlay.hidden = false;
        cartToast.hidden = false;
        requestAnimationFrame(function () {
          cartOverlay.classList.add('is-open');
          cartToast.classList.add('is-open');
        });
        document.body.style.overflow = 'hidden';
      }

      function closeCartToast() {
        if (!cartToast || !cartOverlay) return;
        cartOverlay.classList.remove('is-open');
        cartToast.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function () {
          cartOverlay.hidden = true;
          cartToast.hidden = true;
        }, 350);
      }

      if (cartClose) cartClose.addEventListener('click', closeCartToast);
      if (cartOverlay) cartOverlay.addEventListener('click', closeCartToast);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && cartToast && cartToast.classList.contains('is-open')) closeCartToast();
      });

      function renderCartToastItem(item) {
        if (!cartBody) return;
        var img = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_120x120$1$2') : '';
        var variantLine = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        cartBody.innerHTML =
          '<div class="cpp-cart-toast-item">' +
            (img ? '<img src="' + img + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '">' : '') +
            '<div class="cpp-cart-toast-item-info">' +
              '<p class="cpp-cart-toast-item-title">' + (item.product_title || item.title || '') + '</p>' +
              (variantLine ? '<p class="cpp-cart-toast-item-variant">' + variantLine + '</p>' : '') +
              '<p class="cpp-cart-toast-item-qty-price">Qty ' + item.quantity + ' &middot; ' + formatMoneyOnly(item.final_line_price != null ? item.final_line_price : item.line_price) + '</p>' +
            '</div>' +
          '</div>';
      }

      function renderCartToastCount(cart) {
        if (!cartBody || !cart) return;
        var countEl = document.createElement('div');
        countEl.className = 'cpp-cart-toast-count';
        countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' in your cart \u00b7 ' + formatMoneyOnly(cart.total_price);
        cartBody.appendChild(countEl);
      }

      function renderCartToastError(message) {
        if (!cartBody) return;
        cartBody.innerHTML = '<div class="cpp-cart-toast-error">' + (message || 'Something went wrong. Please try again.') + '</div>';
      }

      function updateGlobalCartCount(cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count').forEach(function (el) {
          try { el.textContent = cart.item_count; } catch (e) {}
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: { cart: cart } }));
      }

      if(qtyInput && qtyMinus && qtyPlus) {
        qtyMinus.addEventListener('click', function(){
          var val = parseInt(qtyInput.value) || 1;
          if(val > 1) qtyInput.value = val - 1;
        });
        qtyPlus.addEventListener('click', function(){
          var val = parseInt(qtyInput.value) || 1;
          qtyInput.value = val + 1;
        });
      }

      /* ===== MOBILE GALLERY IMPROVEMENT: Attach listener to flex container ===== */
      if (mobLeft && mobRight && mainMedia) {
        mobLeft.addEventListener('click', function() {
          mainMedia.scrollBy({ left: -mainMedia.clientWidth, behavior: 'smooth' });
        });
        mobRight.addEventListener('click', function() {
          mainMedia.scrollBy({ left: mainMedia.clientWidth, behavior: 'smooth' });
        });
      }

      // Preserve native formatting logic, but ensure 'Rs.' and '.00' are stripped out if present
      function formatMoneyOnly(cents) {
        var amount = (cents / 100.0);
        var value = amount.toFixed(0); 
        value = value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        return '₹' + value;
      }

      function switchMedia(mediaId) {
        if (mediaId == null) return;
        mediaId = String(mediaId);

        thumbnails.forEach(function (t) {
          t.classList.toggle('is-active', String(t.dataset.mediaId) === mediaId);
        });
        
        var isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (!isMobile) {
          mediaItems.forEach(function (m) {
            m.classList.toggle('is-active', String(m.dataset.mediaId) === mediaId);
          });
        } else {
          var targetItem = mediaItems.find(function(m) { return String(m.dataset.mediaId) === mediaId; });
          if(targetItem && mainMedia) {
             mainMedia.scrollTo({ left: targetItem.offsetLeft, behavior: 'smooth' });
          }
        }

        var activeThumb = thumbnails.filter(function (t) {
          return String(t.dataset.mediaId) === mediaId;
        })[0];
        if (activeThumb && thumbsWrap && !isMobile) {
          var tt = activeThumb.offsetTop;
          if (tt < thumbsWrap.scrollTop || tt + activeThumb.offsetHeight > thumbsWrap.scrollTop + thumbsWrap.clientHeight) {
            thumbsWrap.scrollTo({ top: tt - 2, behavior: 'smooth' });
          }
        }
      }

      thumbnails.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          switchMedia(this.dataset.mediaId);
        });
      });

      function updateArrowState() {
        if (!thumbsWrap || !thumbUp || !thumbDown) return;
        var atTop = thumbsWrap.scrollTop <= 1;
        var atBottom = thumbsWrap.scrollTop + thumbsWrap.clientHeight >= thumbsWrap.scrollHeight - 1;
        thumbUp.disabled = atTop;
        thumbDown.disabled = atBottom;
      }

      if (thumbUp && thumbDown && thumbsWrap) {
        var step = 98; 
        thumbUp.addEventListener('click', function () {
          thumbsWrap.scrollBy({ top: -step, behavior: 'smooth' });
        });
        thumbDown.addEventListener('click', function () {
          thumbsWrap.scrollBy({ top: step, behavior: 'smooth' });
        });
        thumbsWrap.addEventListener('scroll', updateArrowState, { passive: true });
        updateArrowState();
      }

      var sizeBtn = section.querySelector('[data-cpp-size-chart-trigger]');
      var modal   = section.querySelector('[data-cpp-modal]');
      var closers = section.querySelectorAll('[data-cpp-modal-close]');
      if (sizeBtn && modal) {
        sizeBtn.addEventListener('click', function () {
          modal.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        });
        closers.forEach(function (b) {
          b.addEventListener('click', function () {
            modal.setAttribute('hidden', '');
            document.body.style.overflow = '';
          });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
            modal.setAttribute('hidden', '');
            document.body.style.overflow = '';
          }
        });
      }

      function getSelectedOptions() {
        var selected = [];
        var groups = section.querySelectorAll('.cpp-option-group');
        groups.forEach(function (g) {
          var checked = g.querySelector('input:checked');
          if (checked) selected.push(checked.value);
        });
        return selected;
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return opts.every(function (val, i) { return val === v.options[i]; });
        });
      }

      function onVariantChange() {
        var opts = getSelectedOptions();
        var variant = findVariant(opts);
        if (!variant) return;

        if (variantInput) variantInput.value = variant.id;

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}

        if (priceCurrent) priceCurrent.textContent = formatMoneyOnly(variant.price);

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (priceCompare) {
            priceCompare.textContent = formatMoneyOnly(variant.compare_at_price);
            priceCompare.style.display = 'inline-block';
          }
          if (saveBadge && savePct) {
            var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            savePct.textContent = pct;
            saveBadge.style.display = 'inline-block';
          }
        } else {
          if (priceCompare) priceCompare.style.display = 'none';
          if (saveBadge) saveBadge.style.display = 'none';
        }

        if (variant.available) {
          if (atcBtn) atcBtn.disabled = false;
          if (atcText) atcText.textContent = 'ADD TO BAG';
          if (stockNotice) {
            stockNotice.style.display = 'flex';
            if (stockText) stockText.textContent = config.stockText || 'Limited stock available due to high demand';
            var dot = stockNotice.querySelector('.cpp-stock-dot');
            if (dot) dot.style.backgroundColor = config.stockColor || '#d32f2f';
          }
        } else {
          if (atcBtn) atcBtn.disabled = true;
          if (atcText) atcText.textContent = 'SOLD OUT';
          if (stockNotice) {
            stockNotice.style.display = 'flex';
            if (stockText) stockText.textContent = 'Currently out of stock';
            var dot2 = stockNotice.querySelector('.cpp-stock-dot');
            if (dot2) dot2.style.backgroundColor = '#888';
          }
        }

        if (variant.featured_media_id) switchMedia(variant.featured_media_id);
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', onVariantChange);
      });

      if (form && atcBtn) {
        form.addEventListener('submit', function (e) {
          if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) {
            return;
          }
          e.preventDefault();
          var spinner = atcBtn.querySelector('.cpp-spinner');
          atcBtn.disabled = true;
          if (atcText) atcText.style.display = 'none';
          if (spinner) spinner.style.display = 'block';

          var rootUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');

          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          })
          .then(function (r) {
            return r.json().then(function (data) { return { ok: r.ok, data: data }; });
          })
          .then(function (result) {
            if (spinner) spinner.style.display = 'none';
            if (atcText) { atcText.style.display = 'block'; atcText.textContent = 'ADDED ✓'; }
            setTimeout(function () {
              if (atcText) atcText.textContent = 'ADD TO BAG';
              atcBtn.disabled = false;
            }, 1800);

            if (!result.ok) {
              renderCartToastError(result.data && result.data.description ? result.data.description : 'Could not add this item to your cart.');
              openCartToast();
              return;
            }

            renderCartToastItem(result.data);
            openCartToast();

            fetch(rootUrl + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                renderCartToastCount(cart);
                updateGlobalCartCount(cart);
              })
              .catch(function () {});
          })
          .catch(function (err) {
            console.error('CPP cart error:', err);
            if (spinner) spinner.style.display = 'none';
            if (atcText) atcText.style.display = 'block';
            atcBtn.disabled = false;
            renderCartToastError('Could not add this item to your cart. Please try again.');
            openCartToast();
          });
        });
      }
    }

    function boot() {
      document.querySelectorAll('.cpp-wrapper').forEach(initCPP);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('.cpp-wrapper');
      if (sec) { sec.dataset.cppInit = 'false'; initCPP(sec); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-feature-icons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.premium-features-section');
    
    sections.forEach(section => {
      const configEl = section.querySelector('[data-pf-config]');
      if (!configEl) return;
      
      const config = JSON.parse(configEl.textContent);
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      
      if (!isMobile || !config.isMobileSlider) return;

      const track = section.querySelector('[data-pf-slider]');
      const cards = section.querySelectorAll('.pf-card');
      const dotsContainer = section.querySelector('[data-pf-dots]');
      
      if (!track || !cards.length) return;

      // Create Pagination Dots
      cards.forEach((_, i) => {
        const dot = document.createElement('div');
        dot.className = `pf-dot ${i === 0 ? 'is-active' : ''}`;
        dotsContainer.appendChild(dot);
      });
      
      const dots = dotsContainer.querySelectorAll('.pf-dot');
      
      // Update dots on scroll
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = Array.from(cards).indexOf(entry.target);
            dots.forEach(d => d.classList.remove('is-active'));
            if(dots[index]) dots[index].classList.add('is-active');
          }
        });
      }, {
        root: track,
        threshold: 0.6
      });

      cards.forEach(card => observer.observe(card));

      // Autoplay Logic
      if (config.autoScroll) {
        let currentIndex = 0;
        let interval;

        const startAutoplay = () => {
          interval = setInterval(() => {
            currentIndex++;
            if (currentIndex >= cards.length) currentIndex = 0;
            
            track.scrollTo({
              left: cards[currentIndex].offsetLeft - 20,
              behavior: 'smooth'
            });
          }, config.autoScrollSpeed);
        };

        const stopAutoplay = () => clearInterval(interval);

        startAutoplay();

        // Pause on touch/interaction
        track.addEventListener('touchstart', stopAutoplay, { passive: true });
        track.addEventListener('touchend', startAutoplay, { passive: true });
        track.addEventListener('mouseenter', stopAutoplay);
        track.addEventListener('mouseleave', startAutoplay);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
